export default __webpack_public_path__ + "static/media/quality_control.dfb2f7f3.png";